<template>
  <b-modal id="submit-to-store-confirmation-modal" hide-header hide-footer ref="submitToStoreModal" :no-close-on-esc="noCloseOnBackdrop" :no-close-on-backdrop="noCloseOnBackdrop" :hide-header-close="noCloseOnBackdrop">
    <div>
      <div class="graphic-container">
        <img src="static/img/submit-to-app-store.svg" class="mobile" />
        <img src="static/img/icn-checkmark-new.svg" class="checkmark" />
      </div>
      <div class="heading">Confirm App Store Submission</div>
      <div class="description">
        You are submitting your iOS app for App Store review. For information on submitting your Android app to the Google Play Store, or for iOS App approval status, please reach out to your THREAD representative.
      </div>
      <div class="mod-footer mt-34">
        <div>
          <button type="button" class="btn btn-primary" @click="submitToAppStore">
            OK
          </button>
        </div>
        <div class="mt-20"><a @click="hide" class="cancel">Cancel</a></div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import "nprogress/nprogress.css";

export default {
  name: "submit-to-app-store-modal",
  props: [],
  data() {
    return {
      noCloseOnBackdrop: true,
      studyId: this.$route.params.studyId
    };
  },
  methods: {
    show() {
      this.$refs.submitToStoreModal.show();
    },
    hide() {
      this.$refs.submitToStoreModal.hide();
    },
    submitToAppStore() {
      this.$api.postStudyBuildFact(this.studyId, { build_type: "app-store" }).then(
        () => {},
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while submitting to app store");
        }
      );
      this.hide();
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
@media (min-width: 992px) {
  #submit-to-store-confirmation-modal {
    .modal-dialog.modal-md {
      min-width: 600px !important;
    }
  }
}

#submit-to-store-confirmation-modal {
  .modal-dialog {
    .modal-content {
      text-align: center !important;
      .modal-body {
        padding: 50px 90px 41px 90px;
        color: #666669;
        font-size: 14px;
        .heading {
          font-size: 20px;
          font-weight: bold;
          color: #666669;
          margin-bottom: 18px;
          margin-top: 22px;
        }
        .description {
          opacity: 0.7;
        }
        .mod-footer {
          button {
            &.btn-primary {
              background-color: #4c8ce4;
              border-color: #4c8ce4;
              padding: 6px 86px;
              border-radius: 100px;
              font-weight: normal;
              font-size: 14px;
            }
          }
          a {
            &.cancel {
              color: #4c8ce4;
              font-weight: 500;
              cursor: pointer;
            }
          }
        }
        .graphic-container {
          position: relative;
          top: 0;
          left: 0;
          .mobile {
            position: relative;
          }
          .checkmark {
            position: absolute;
            top: -7%;
            right: 36%;
          }
        }
      }
    }
  }
}
</style>
